module.exports = __webpack_public_path__ + "img/ni.f5bbc85a.svg";